/**
 * The superMenu is a list of all the pages and sections on the site.
 * It is used to generate the navbar and the sidebar.
 * It is also used to generate the breadcrumbs.
 * It is also used to generate the footer.
 * It is also used to generate the sitemap.
 * It is also used to generate the robots.txt.
 * It is also used to generate the manifest.json.
 * It is also used to generate the .env.local.
 *
 * Do NOT export superMenu from this file, use getters instead.
 */

export interface MenuItem {
  key: string
  label: string
  description: string
  href: string
}

export interface SubMenuImage {
  url: string
  width: number
  height: number
}

export interface PrimaryMenuItem extends MenuItem {
  subPages?: MenuItem[]
  image?: SubMenuImage
}
